export default __webpack_public_path__ + "static/media/tiktok-boxed-icon.887e1c71.svg";